import { TImportCustomerUserRow } from "@/api/services/main/customer-user/dtos/customer-user.dto";
import { CENTER_TOKEN_KEY } from "@/constants/common";
import { baseURL } from "@/utils/api";
import Cookies from "js-cookie";

export type TImportStreamChunk = {
  progress: number; // 0..100 while running, -1 on error
  successCount?: number; // present on the final success chunk
  message?: string;
  code?: string;
  error?: unknown;
};

/**
 * Consumes the NDJSON progress stream from POST /users/import.
 * Uses native fetch (not the axios clientApi) because axios buffers the whole
 * response — streaming needs ReadableStream.. Note: no automatic token refresh here;
 * a 401 surfaces as a !ok response → error chunk (import is a fresh user action).
 */
export const importCustomerUsersStream = async (rows: TImportCustomerUserRow[], onChunk: (chunk: TImportStreamChunk) => void): Promise<void> => {
  const token = Cookies.get(CENTER_TOKEN_KEY);

  const response = await fetch(`${baseURL}/users/import`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ rows }),
  });

  const reader = response.body?.getReader();
  if (!response.ok || !reader) {
    onChunk({ progress: -1, message: "不明なエラー。", code: "UNKNOWN_ERROR" });
    return;
  }

  const decoder = new TextDecoder();
  let buffer = "";

  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split("\n");
    buffer = lines.pop() ?? "";
    for (const line of lines) {
      if (!line.trim()) continue;
      try {
        onChunk(JSON.parse(line) as TImportStreamChunk);
      } catch {
        // ignore partial/non-JSON lines
      }
    }
  }
};
